/* tslint:disable */
/* eslint-disable */
/**
 * Care& API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.9.4
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { SavedPromptRequestField } from './SavedPromptRequestField';
import {
    SavedPromptRequestFieldFromJSON,
    SavedPromptRequestFieldFromJSONTyped,
    SavedPromptRequestFieldToJSON,
} from './SavedPromptRequestField';

/**
 * 
 * @export
 * @interface SavedPromptRequest
 */
export interface SavedPromptRequest {
    /**
     * 
     * @type {string}
     * @memberof SavedPromptRequest
     */
    patient_id?: string;
    /**
     * 
     * @type {string}
     * @memberof SavedPromptRequest
     */
    document_id?: string;
    /**
     * 
     * @type {string}
     * @memberof SavedPromptRequest
     */
    template_id?: string;
    /**
     * 
     * @type {number}
     * @memberof SavedPromptRequest
     */
    budget_tokens?: number;
    /**
     * 
     * @type {Array<SavedPromptRequestField>}
     * @memberof SavedPromptRequest
     */
    fields?: Array<SavedPromptRequestField>;
}

/**
 * Check if a given object implements the SavedPromptRequest interface.
 */
export function instanceOfSavedPromptRequest(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function SavedPromptRequestFromJSON(json: any): SavedPromptRequest {
    return SavedPromptRequestFromJSONTyped(json, false);
}

export function SavedPromptRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): SavedPromptRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'patient_id': !exists(json, 'patient_id') ? undefined : json['patient_id'],
        'document_id': !exists(json, 'document_id') ? undefined : json['document_id'],
        'template_id': !exists(json, 'template_id') ? undefined : json['template_id'],
        'budget_tokens': !exists(json, 'budget_tokens') ? undefined : json['budget_tokens'],
        'fields': !exists(json, 'fields') ? undefined : ((json['fields'] as Array<any>).map(SavedPromptRequestFieldFromJSON)),
    };
}

export function SavedPromptRequestToJSON(value?: SavedPromptRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'patient_id': value.patient_id,
        'document_id': value.document_id,
        'template_id': value.template_id,
        'budget_tokens': value.budget_tokens,
        'fields': value.fields === undefined ? undefined : ((value.fields as Array<any>).map(SavedPromptRequestFieldToJSON)),
    };
}

